/* eslint-disable */
(function(algolia) {
  'use strict';
  const insightsClient = algolia.externals.insightsClient;
  const createAlgoliaInsightsPlugin = algolia.externals.createAlgoliaInsightsPlugin;
  const createInsightsMiddleware = algolia.externals.createInsightsMiddleware;
  algolia.userTokenCheck = false;

  const enabled = algolia.config.analytics_enabled;
  if (!enabled) return;

  // useCookie parameter set up
  const userTokenAdminSetting = algolia.config.usertoken_with_cookies === 'enabled';
  // Generate a random alpha-numeric string that's 20 characters long

  function generateAnonymousUserToken() {
    function randomHexSegment(length) {
      return Array.from({ length }, () => Math.floor(Math.random() * 16).toString(16)).join('');
    }

    return `anonymous-${randomHexSegment(8)}-${randomHexSegment(4)}-${randomHexSegment(4)}-${randomHexSegment(4)}-${randomHexSegment(12)}`;
  }

  window.Shopify.loadFeatures(
    [
      {
        name: 'consent-tracking-api',
        version: '0.1',
      },
    ],
    error => {
      if (error) {
        console.error("Customer Privacy API Error", error);
      }
      const userCanBeTracked = window.Shopify.customerPrivacy ? window.Shopify.customerPrivacy.userCanBeTracked() : false;
      const useCookie = userTokenAdminSetting && userCanBeTracked;
      insightsClient('init', {appId: algolia.config.app_id, apiKey: algolia.config.search_api_key, useCookie});
      algolia.userTokenCheck = true;


      if(userCanBeTracked) {
        if(window.theme.customer.algoliaUserToken) {
            const userToken = `${window.theme.customer.algoliaUserToken}`;
            insightsClient('setUserToken', userToken);
            localStorage.setItem('aa-user-token', userToken);
          } else {

            if(localStorage.getItem('aa-user-token')) {
              const userToken = localStorage.getItem('aa-user-token');
              insightsClient('setUserToken', userToken);
            } else {
              const userToken = generateAnonymousUserToken();
              insightsClient('setUserToken', userToken);
              localStorage.setItem('aa-user-token', userToken);
            }
          }

        localStorage.setItem(
          'algolia_config',
            JSON.stringify({
              app_id: algolia.config.app_id,
              search_api_key: algolia.config.search_api_key,
              index_name: `${algolia.config.index_prefix}products`,
              user_token: localStorage.getItem('aa-user-token'),
            })
          )
        }
      },
    );

  // Autocomplete insight initialization
  algolia.algoliaInsightsPlugin = createAlgoliaInsightsPlugin({ insightsClient });
  // IS insight initialization
  algolia.insightsMiddleware = createInsightsMiddleware({ insightsClient })

  // Local storage logic for conversion events

  /**
   * Saves details in local storage for conversion tracking
   */
  algolia.saveForConversionTracking = function (data) {
    const localStorageKey = 'algolia_analytics_clicked_objects';
    /**
     * We're using a try, catch here to handle any possible exceptions
     * resulting from local storage or JSON parsing.
     */
    try {
      // Get any data previously stored
      const previousClickItemsString = localStorage.getItem(localStorageKey) || '[]';
      const previousClickItems = JSON.parse(previousClickItemsString);

      var conversionData = data;

      if (conversionData.eventName === "click") {
        // Changing the event to 'Added to cart' from 'click'
        conversionData.eventName = 'Added to cart';
        // Removing the `positions` property if the event comes from IS
        delete conversionData.positions;
      }

      // Add the current products data to local storage
      previousClickItems.push(conversionData)
      localStorage.setItem(localStorageKey, JSON.stringify(previousClickItems))
    } catch (error) {
      // No need to do anything in this scenario
    }
  };
})(window.algoliaShopify);
